import { findIndex } from "@dhx/ts-common/core";
import { Grid } from "./Grid";
import { GridEvents } from "./types";
import { getScrollbarWidth } from "../../ts-common/html";

export function startResize(grid: Grid, column: string, ev: MouseEvent, cb: any) {
	const initX = ev.clientX;
	let initWidth = 0;
	grid.config.$resizing = column;

	const moveHandler = e => {
		const i = findIndex(grid.config.columns, obj => {
			return obj.id === column;
		});
		const containerLeft = e.clientX - grid.getRootNode().getBoundingClientRect().left;
		const scrollbarY = grid.config.$totalHeight > grid.config.height ? getScrollbarWidth() : 0;
		if((grid.config.splitAt === i+1) && (containerLeft >= grid.config.width - scrollbarY - 2)) {
			return;
		}

		initWidth = initWidth || grid.config.columns[i].width;
		const minWidth = grid.config.columns[i].minWidth || 20;
		const maxWidth = grid.config.columns[i].maxWidth;
		const move = e.clientX - initX;
		const cols = [...grid.config.columns];
		const size = initWidth + move;
		let final;
		if ((maxWidth && size >= maxWidth) || size <= minWidth) {
			if (size <= minWidth) {
				final = minWidth;
			}
			if (size >= maxWidth) {
				final = maxWidth;
			}
		} else {
			final = size;
		}
		cols[i].width = final;
		grid.events.fire(GridEvents.resize, [grid.config.columns[i], e]);
		grid.paint();
	};

	const upHandler = () => {
		document.removeEventListener("mousemove", moveHandler);
		document.removeEventListener("mouseup", upHandler);
		cb();
	};
	document.addEventListener("mousemove", moveHandler);
	document.addEventListener("mouseup", upHandler);
	grid.paint();
}